module.exports = __webpack_public_path__ + "static/media/maal-m.7628e2f8.mp3";